export const hashString = (str: string) => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i)
    hash = (hash << 5) - hash + charCode
    hash = hash & 0xffffffff
  }
  return hash
}

export const getTextColor = (bgColor: string): string => {
  const r = parseInt(bgColor.slice(1, 3), 16)
  const g = parseInt(bgColor.slice(3, 5), 16)
  const b = parseInt(bgColor.slice(5, 7), 16)
  const brightness = (r * 299 + g * 587 + b * 114) / 1000
  return brightness < 150 ? '#f0f0f0' : '#4A4A4A'
}

const rgbToHsv = (r: number, g: number, b: number): [number, number, number] => {
  r /= 255
  g /= 255
  b /= 255
  const max = Math.max(r, g, b),
    min = Math.min(r, g, b)
  const d = max - min
  let h = 0 // 色相
  const s = max === 0 ? 0 : d / max // 彩度
  const v = max // 明度

  if (max !== min) {
    if (max === r) {
      h = (g - b) / d + (g < b ? 6 : 0)
    } else if (max === g) {
      h = (b - r) / d + 2
    } else {
      h = (r - g) / d + 4
    }
    h /= 6
  }

  return [h, s, v]
}

const hsvToRgb = (h: number, s: number, v: number): [number, number, number] => {
  const i = Math.floor(h * 6)
  const f = h * 6 - i
  const p = v * (1 - s)
  const q = v * (1 - f * s)
  const t = v * (1 - (1 - f) * s)
  let r = 0,
    g = 0,
    b = 0

  switch (i % 6) {
    case 0:
      r = v
      g = t
      b = p
      break
    case 1:
      r = q
      g = v
      b = p
      break
    case 2:
      r = p
      g = v
      b = t
      break
    case 3:
      r = p
      g = q
      b = v
      break
    case 4:
      r = t
      g = p
      b = v
      break
    case 5:
      r = v
      g = p
      b = q
      break
  }

  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)]
}

export const adjustColor = (color: string, sFactor?: number, vFactor?: number): string => {
  const [r, g, b] = color.match(/\w\w/g)!.map((hex) => parseInt(hex, 16))
  const [h, sInit, vInit] = rgbToHsv(r, g, b)

  let s = sInit
  let v = vInit

  if (sFactor !== undefined) {
    // 彩度の調整
    s = 1 - sFactor
    v = 1
  }

  if (vFactor !== undefined) {
    // 明度の調整
    v = vFactor
  }

  const [rAdjusted, gAdjusted, bAdjusted] = hsvToRgb(h, s, v)

  return `#${rAdjusted.toString(16).padStart(2, '0')}${gAdjusted
    .toString(16)
    .padStart(2, '0')}${bAdjusted.toString(16).padStart(2, '0')}`
}
